import { dom } from '@assets/js/utilities/dom.js'

export const $nav = dom('.product-swiper')
export const $display = dom('#product-display-area')

if (!$nav || !$display) {
    throw new Error('[producto] No se encontró el área de producto.')
}
